import AgentAPI from "agent-api";

//
// Summary
//

/*

Abstraction layer for agent api private xml storage. Made such
to enable other or potentaly multiple diferent storage locations
or methods on a neuron or other services

Note that the cache system currently relies that no changes have been made outside
of this storage unit, and if 100% correct data is required you can flush the cache

*/

const DEFAULT_XML_NAMESPACE = "http://www.w3.org/2001/XMLSchema";

export default function RemoteStorageUnit({
  namespace = DEFAULT_XML_NAMESPACE,
  localname,
  loadOnInit = true,
}) {
  let cache = undefined;

  console.debug("storage unit initialized");

  const store = async (jsonData) => {
    await AgentAPI.Storage.SavePrivateXml(
      `<${localname} xmlns="${namespace}"><![CDATA[${JSON.stringify(
        jsonData
      )}]]></${localname}>`
    );
  };

  const load = async () => {
    try {
      const res = await AgentAPI.Storage.LoadPrivateXml(localname, namespace);
      const data = JSON.parse(res.Xml.value);
      if (data === undefined || typeof data !== "object") throw res;
      cache = data;
    } catch (err) {
      if (!!err.Xml || err.message === "Private XML not found.") {
        console.debug(
          (err.Xml ? "invalid data" : "no data") +
            ": creating clean slate in remote storage unit"
        );
        if (err === null) {
          console.log(err);
        }
        await setData({});
      } else {
        console.error(err);
      }
    }
  };

  const flushCache = async () => {
    cache = undefined;
    await load();
  };

  const setData = async (jsonData) => {
    cache = structuredClone(jsonData);
    store(jsonData);
  };

  if (loadOnInit) {
    // loads the current data to fill the cache
    load();
  }

  return {
    get data() {
      return Object.freeze({ ...cache });
    }, // make it imutable
    setData,
    flush: flushCache,
  };
}
